const range = (prefix, from, to) =>
	Array.from({ length: to - from + 1 }, (_, i) => `${prefix} ${from + i}`);

/**
 * Starter bundles an admin can add to the tag bank in one click.
 */
export const TAG_PRESETS = [
	{ id: "ecd", label: "Early childhood", tags: ["ECD A", "ECD B"] },
	{ id: "primary", label: "Primary grades", tags: range("Grade", 1, 7) },
	{ id: "secondary", label: "Secondary forms", tags: range("Form", 1, 6) },
	{
		id: "subjects",
		label: "Core subjects",
		tags: [
			"Mathematics",
			"English",
			"Science",
			"Shona",
			"Ndebele",
			"History",
			"Geography",
			"Agriculture",
			"ICT",
			"Heritage Studies",
		],
	},
	{
		id: "levels",
		label: "Exam levels",
		tags: ["ZIMSEC", "Cambridge", "O Level", "A Level"],
	},
	{
		id: "audience",
		label: "Audience",
		tags: ["Teacher Resource", "Learner Workbook", "Revision Guide", "Past Papers"],
	},
];

/**
 * Split free text into distinct, trimmed tag names (comma or newline separated).
 */
export const parseTagNames = (text) => {
	const seen = new Set();
	return (text || "")
		.split(/[\n,]/)
		.map((part) => part.trim())
		.filter(Boolean)
		.filter((name) => {
			const key = name.toLowerCase();
			if (seen.has(key)) return false;
			seen.add(key);
			return true;
		});
};
